import React from "react";

/**
 * Bandeau d'avertissement « Alpha » affiché en tête des nouveaux onglets B2B
 * (Pipeline, SAV B2B, Impayés, Rapprochement, Dashboard data).
 *
 * Objectif : prévenir que les données et fonctionnalités ne sont pas encore
 * fiabilisées, qu'elles sont susceptibles de changer, et inviter aux retours.
 */
const AlphaBanner = ({ feature, contactConnecteam }) => {
  return (
    <div
      role="note"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        background: "#FFF8E1",
        border: "1px solid #F2C94C",
        borderLeft: "4px solid #F2994A",
        borderRadius: 8,
        padding: "10px 14px",
        margin: "0 0 16px",
        fontSize: 13,
        lineHeight: 1.45,
        color: "#5c4400",
      }}
    >
      <span
        style={{
          flexShrink: 0,
          background: "#F2994A",
          color: "#fff",
          fontWeight: 700,
          fontSize: 11,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          borderRadius: 4,
          padding: "2px 8px",
          marginTop: 1,
        }}
      >
        Alpha
      </span>
      <div>
        <strong>
          {feature ? `« ${feature} » est en version alpha.` : "Fonctionnalité en version alpha."}
        </strong>{" "}
        Les données affichées et les fonctionnalités ne sont pas encore
        fiabilisées et sont fortement susceptibles de changer. À utiliser avec
        prudence et à recouper si besoin.
        <br />
        {contactConnecteam ? (
          <span>
            Vous pouvez poser vos questions et faire vos retours à{" "}
            <strong>Romain (pôle SI)</strong> sur <strong>Connecteam</strong>.
          </span>
        ) : (
          <span>
            Tous vos retours sont les bienvenus&nbsp;:{" "}
            <a
              href="https://lemoulin.typeform.com/to/PworxMa6?embed=1"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#b5651d", fontWeight: 600, textDecoration: "underline" }}
            >
              faire un retour
            </a>
            .
          </span>
        )}
      </div>
    </div>
  );
};

export default AlphaBanner;
